import React, { useEffect, useState } from 'react'
import DataMapperFilters from './DataMapperFilters'
import {
    useMapperActionsMutation,
    useGetMapperMutation,
} from '../../Redux/Admin_Tasks/DataMapperSlice'
import { FoundationsConstants } from '../../FoundationsConstants'
import { FoundationsEnums } from '../../enum'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'

interface MapperActionProps {
    Action: string
    Rows: { [key: string]: any }[]
    ParentFields: { [key: string]: any }[]
    Key: string
    FilterValues: { [key: string]: any }
    LoadMapperResults: (Status: string, Message: string) => void
}

declare let window: any
const UnicornApp = window.unicornInstance as any

const MapperActions: React.FC<MapperActionProps> = ({
    Action,
    Rows,
    ParentFields,
    Key,
    FilterValues,
    LoadMapperResults,
}) => {
    const [Mapper, setMapper] = useState(null)
    const [NewRows, setNewRows] = useState<{ [key: string]: any }[]>(Rows)
    const [ColumnNames, setColumnNames] = useState<string[]>([])
    const [LoadFilters, setLoadFilters] = useState(false)
    const [showConformation, setShowConformation] = useState(false)
    const [getFilters, { isLoading }] = useGetMapperMutation()
    const [PerformAction, { isLoading: ActionLoading }] = useMapperActionsMutation()

    const SetFilters = (payload: any) => {
        setMapper(payload.data)
        const attributeList = payload.data.Value?.AttributeList
        const columns =
            attributeList && attributeList[0]?.Prop0
                ? attributeList[0].Prop0.split(',').slice(1)
                : []
        setColumnNames(columns)
        setLoadFilters(true)
    }

    useEffect(() => {
        if (Action === 'Edit' || Action === 'Add') {
            const fetchData = async () => {
                const GetFiltersResponse = await getFilters({
                    key: Key,
                    action: 'ButtonAction',
                    data: [FilterValues],
                })
                if (!isLoading) {
                    SetFilters(GetFiltersResponse.data)
                }
            }
            if (Key) {
                fetchData()
            }
        } else if (Action === 'Delete') {
            setColumnNames(Object.keys(Rows[0]).filter((key) => key !== 'Id'))
            setNewRows(Rows)
        }
    }, [Key])

    const GetDropdownValues = async (DropdownValues: { [key: string]: any }) => {
        const newRows = Rows.map((row) => ({ ...row }))
        newRows.forEach((newRow) => {
            Object.keys(DropdownValues).forEach((key) => {
                if (
                    !ParentFields.some((item) => item.Column === key) &&
                    DropdownValues[key] !== ''
                ) {
                    newRow[key] = DropdownValues[key]
                }
            })
        })
        setNewRows(newRows)
        const GetFiltersResponse = await getFilters({
            key: Key,
            action: 'ButtonAction',
            data: [DropdownValues],
        })
        if (!isLoading) {
            SetFilters(GetFiltersResponse.data)
        }
    }

    const ToggleConformation = () => {
        if (Action === 'Add' && 
            Object.values(NewRows[0]).filter((value) => value !== '').length !== ColumnNames.length)  {
            FoundationsGenericToaster('error', 'Select all columns before confirming add')
        } else {
            if (showConformation) {
                setNewRows(Rows)
            }
            setShowConformation(!showConformation)
        }
    }

    const ActionConfirmation = async () => {
        if (Action === 'Add') {
            const AddMapperResponse = await PerformAction({
                key: Key,
                action: 'Insert',
                data: NewRows,
            })
            if (!ActionLoading) {
                if (AddMapperResponse.data.statusMessage.toLowerCase() === FoundationsConstants.Response.Success) {
                    if(AddMapperResponse.data.data.Value.Data[0].Result!=0){
                        LoadMapperResults(FoundationsConstants.Response.Success, AddMapperResponse.data.data.Value?.Data[0].Status)
                    }
                    else{
                        LoadMapperResults(FoundationsConstants.Response.Error, AddMapperResponse.data.data.Value?.Data[0].Status)
                    }
                      
                } else {
                    LoadMapperResults(FoundationsConstants.Response.Error, 'Could Not Add Mapper')
                }
            }
        } else if (Action === 'Edit') {
            const EditMapperResponse = await PerformAction({
                key: Key,
                action: 'Update',
                data: NewRows,
            })
            if (!ActionLoading) {
                if (EditMapperResponse.data.statusMessage.toLowerCase() === FoundationsConstants.Response.Success) {
                    LoadMapperResults(FoundationsConstants.Response.Success, EditMapperResponse.data.data.Value?.Data[0].Status)
                } else {
                    LoadMapperResults(FoundationsConstants.Response.Error, 'Could Not Update Mapper')
                }
            }
        } else if (Action === 'Delete') {
            const DeleteMapperResponse = await PerformAction({
                key: Key,
                action: 'Delete',
                data: NewRows,
            })
            if (!ActionLoading) {
                if (DeleteMapperResponse.data.statusMessage.toLowerCase() === FoundationsConstants.Response.Success) {
                    LoadMapperResults(
                        FoundationsConstants.Response.Success,
                        DeleteMapperResponse.data.data.Value?.Data[0].Status
                    )
                } else {
                    LoadMapperResults(FoundationsConstants.Response.Error, 'Could Not Delete Mapper')
                }
            }
        }
    }

    if (showConformation || Action === 'Delete') {
        return (
            <div id="mapper-edit-panel">
                {Action === 'Add' && <div className="h5 mt-2"> Rows to add </div>}
                {Action === 'Edit' && <div className="h5 mt-2"> Original Row(s)</div>}
                {Action === 'Delete' && (
                    <div className="h6 mt-3">
                        {' '}
                        Are you sure you wish to delete the following row(s)
                    </div>
                )}
                {Action === 'Edit' && (
                    <div id="mapper-old-rows" className="mb-2">
                        <table className="admin-table">
                            <thead>
                                <tr id="editHeader" className="admin-row-header">
                                    {ColumnNames.map((columnName) => (
                                        <th className="text-center">{columnName}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody id="editMapperResults">
                                {Rows.map((Row) => (
                                    <tr>
                                        {ColumnNames.map((columnName) => (
                                            <td>
                                                <div className="data_results_field result_data">
                                                    {Row[columnName]}
                                                </div>
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="h5 mt-3"> Rows to edit </div>
                    </div>
                )}
                <div id="mapper-old-rows" className="mb-2">
                    <table className="admin-table">
                        <thead>
                            <tr id="editHeader" className="admin-row-header">
                                {ColumnNames.map((columnName) => (
                                    <th className="text-center">{columnName}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody id="editMapperResults">
                            {NewRows.map((newRow) => (
                                <tr>
                                    {ColumnNames.map((columnName) => (
                                        <td>
                                            <div className="data_results_field result_data">
                                                {newRow[columnName]}
                                            </div>
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <button
                    id="back-changes"
                    className="app-button negative float-right"
                    onClick={
                        Action === 'Delete' ? () => LoadMapperResults('', '') : ToggleConformation
                    }
                >
                    Back
                </button>
                <button
                    id="submit-changes"
                    className="app-button float-right"
                    onClick={ActionConfirmation}
                >
                    Submit Changes
                </button>
            </div>
        )
    } else {
        return (
            <div id="mapper-edit-panel">
                {Action === 'Add' && (
                    <div>
                        <div className="h6 mt-3"> Adding the following row(s)</div>
                        <table className="admin-table">
                            <tfoot id="mapper-filter-options">
                                {!LoadFilters && <div> </div>}
                                {LoadFilters && (
                                    <DataMapperFilters
                                        columns={ColumnNames}
                                        Mapper={Mapper}
                                        ParentFields={ParentFields}
                                        FilterValues={FilterValues}
                                        FiltersUpdated={GetDropdownValues}
                                    />
                                )}
                            </tfoot>
                        </table>
                    </div>
                )}
                {Action === 'Edit' && (
                    <div>
                        <div className="h6 mt-3"> Editing the following row(s)</div>
                        <div id="mapper-edit-rows">
                            <table className="admin-table">
                                <thead>
                                    <tr id="editHeader" className="admin-row-header">
                                        {ColumnNames.map((columnName) => (
                                            <th className="text-center">{columnName}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody id="editMapperResults">
                                    {Rows.map((Row) => (
                                        <tr>
                                            {ColumnNames.map((columnName) => (
                                                <td>
                                                    <div className="data_results_field result_data">
                                                        {Row[columnName]}
                                                    </div>
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot id="mapper-filter-options">
                                    {!LoadFilters && <div> </div>}
                                    {LoadFilters ? (
                                        <>
                                        <DataMapperFilters
                                            columns={ColumnNames}
                                            Mapper={Mapper}
                                            ParentFields={ParentFields}
                                            FilterValues={FilterValues}
                                            FiltersUpdated={GetDropdownValues}
                                        />
                                        <span style={{ fontSize: '11px' }}> * Parent Fields are not editable</span>
                                        </>
                                    ):(
                                        <>
                                            <div>
                                                <div className="h6 mt-3"></div>
                                                <div id="mapper-edit-rows">
                                                    <table className="admin-table">
                                                        <thead>
                                                            <tr id="editHeader" className="admin-row-header">

                                                            </tr>
                                                        </thead>
                                                        <tbody className="editMapperResults">
                                                        </tbody>
                                                        <tfoot id="mapper-filter-options">
                                                        </tfoot>
                                                    </table>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </tfoot>
                            </table>
                        </div>
                    </div>
                )}
                {LoadFilters ? (
                    <>
                        <button
                            id="cancel-changes"
                            className="app-button negative float-right"
                            onClick={() => LoadMapperResults('', '')}
                        >
                            Cancel
                        </button>
                        <button
                            id="confirm-changes"
                            className="app-button float-right"
                            onClick={ToggleConformation}
                        >
                            Confirm
                        </button>
                    </>) : (<></>)
                }
            </div>
        )
    }
}

export default MapperActions
